import {createReducer, on} from '@ngrx/store';
import {initialState} from './cistern.state';
import {CisternActions} from './cistern.actions';

export const cisternReducer = createReducer(
  initialState,

  on(CisternActions.public.updateCisternFilter, (state, {filter}) =>({
    ...state,
    filter: filter
  })),

  on(CisternActions.private.loadCisternsWithFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(CisternActions.private.loadCisternsSuccess, (state, props) => {
    const entities = {...state.entities};
    props.cisternsResponseDto.cisterns.forEach((it) => {
      entities[it.id!!] = it;
    });

    return {
      ...state,
      entities: entities,
      pages: {
        ...state.pages,
        [state.filter!!.page!!]: props.cisternsResponseDto.cisterns.map((it) => it.id!!),
      },
      totalCount: props.cisternsResponseDto.totalCount,
      isLoading: false,
      error: null,
    };
  }),

  on(CisternActions.private.loadCisternsFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(CisternActions.private.loadCisternsWithProvidedFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(CisternActions.private.loadCisternsWithProvidedFiltersSuccess, (state, props) => {
    const entities = {...state.entities};
    props.cisternsResponseDto.cisterns.forEach((it) => {
      entities[it.id!!] = it;
    });

    return {
      ...state,
      entities,
      isLoading: false,
      error: null,
    };
  }),

  on(CisternActions.private.loadCisternsWithProvidedFiltersFailure, (state, error) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(CisternActions.public.loadAllCisternsByFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(CisternActions.private.loadAllCisternsByFiltersSuccess, (state, props) => {
    return {
      ...state,
      isLoading: false,
      error: null,
    };
  }),

  on(CisternActions.private.loadAllCisternsByFiltersFailure, (state, error) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(CisternActions.private.loadNextOfAll, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(CisternActions.private.loadNextOfAllSuccess, (state, props) => {
    const entities = {...state.entities};
    props.cisternsResponseDto.cisterns.forEach((it) => {
      entities[it.id!!] = it;
    });

    return {
      ...state,
      entities: entities,
    };
  }),

  on(CisternActions.private.loadNextOfAllFailure, (state, error) => ({
    ...state,
    isLoading: false,
    error: error,
  })),

  on(CisternActions.public.createCistern, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(CisternActions.private.createCisternSuccess, (state, {responseDto}) => ({
    ...state,
    entities: {
      ...state.entities,
      [responseDto.id]: responseDto,
    },
    isLoading: false,
    error: null,
  })),

  on(CisternActions.private.createCisternFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(CisternActions.public.updateCistern, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(CisternActions.private.updateCisternSuccess, (state, {responseDto}) => ({
    ...state,
    entities: {
      ...state.entities,
      [responseDto.id]: responseDto,
    },
    isLoading: false,
    error: null,
  })),

  on(CisternActions.private.updateCisternFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(CisternActions.public.deleteCisternById, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(CisternActions.private.deleteCisternSuccess, (state, {id}) => {
    const entities = {...state.entities};
    delete entities[id];

    const pages = Object.fromEntries(
      Object.entries(state.pages).map(([page, ids]) => [page, ids.filter((it) => it !== id)]),
    );

    return {
      ...state,
      entities,
      pages,
      totalCount: Math.max(0, state.totalCount - 1),
      isLoading: false,
      error: null,
    };
  }),

  on(CisternActions.private.deleteCisternFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),
);
